import { CONVENTIONAL } from 'helpers/globals'

export default function fovModeHelper(mode) {
  return mode === CONVENTIONAL ? 'horizontal' : 'vertical'
}



// WEBPACK FOOTER //
// ./src/helpers/fovModeHelper.js